import { disablePowerIcon } from '../state/ui-store';

export const disablePowerBttn = () => disablePowerIcon();
